import type React from 'react';
import { BusinessRegistrationForm } from '@/components/auth/business-registration-form';

export const RegisterBusiness: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <BusinessRegistrationForm onBack={() => window.history.back()} />
    </div>
  );
};
